import {
    GET_STATE,
    GET_STATE_SUCCESS,
    GET_STATE_FAIL,
    GET_OCCUPATION,
    GET_OCCUPATION_SUCCESS,
    GET_OCCUPATION_FAIL,
    GET_RELATEDPERSONTYPE,
    GET_RELATEDPERSONTYPE_SUCCESS,
    GET_RELATEDPERSONTYPE_FAIL,
    GET_EDUCATION,
    GET_EDUCATION_SUCCESS,
    GET_EDUCATION_FAIL,
    GET_OCCUPATIONDETAILS,
    GET_OCCUPATIONDETAILS_SUCCESS,
    GET_OCCUPATIONDETAILS_FAIL,
    GET_ASSETDETAILS,
    GET_ASSETDETAILS_SUCCESS,
    GET_ASSETDETAILS_FAIL,
    GET_OTHERBANKACCOUNTS,
    GET_OTHERBANKACCOUNTS_SUCCESS,
    GET_OTHERBANKACCOUNTS_FAIL,
    GET_ACCOUNTTYPE,
    GET_ACCOUNTTYPE_SUCCESS,
    GET_ACCOUNTTYPE_FAIL,
    GET_ENTITYTYPE,
    GET_ENTITYTYPE_SUCCESS,
    GET_ENTITYTYPE_FAIL,
    GET_LOCATION,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_FAIL,
    GET_BRANCH,
    GET_BRANCH_SUCCESS,
    GET_BRANCH_FAIL,
    GET_POI,
    GET_POI_SUCCESS,
    GET_POI_FAIL,
    GET_REASON_TO_BECOME_CUSTOMER,
    GET_REASON_TO_BECOME_CUSTOMER_SUCCESS,
    GET_REASON_TO_BECOME_CUSTOMER_FAIL
} from "./actionTypes";

//GetAll State actions
export const getState = () => ({
    type: GET_STATE,
});

export const getStateSuccess = data => ({
    type: GET_STATE_SUCCESS,
    payload: data,
});
export const getStateFail = error => ({
    type: GET_STATE_FAIL,
    payload: error,
});

//GetAll Occupation actions
export const getOccupation = () => ({
    type: GET_OCCUPATION,
});
export const getOccupationSuccess = data => ({
    type: GET_OCCUPATION_SUCCESS,
    payload: data,
});
export const getOccupationFail = error => ({
    type: GET_OCCUPATION_FAIL,
    payload: error,
});

//GetAll Related_Person_Type
export const getRelatedPersonType = () => ({
    type: GET_RELATEDPERSONTYPE,
});
export const getRelatedPersonTypeSuccess = data => ({
    type: GET_RELATEDPERSONTYPE_SUCCESS,
    payload: data,
});
export const getRelatedPersonTypeFail = error => ({
    type: GET_RELATEDPERSONTYPE_FAIL,
    payload: error,
});

//GetAll Education
export const getEducation = () => ({
    type: GET_EDUCATION,
});
export const getEducationSuccess = data => ({
    type: GET_EDUCATION_SUCCESS,
    payload: data,
});
export const getEducationFail = error => ({
    type: GET_EDUCATION_FAIL,
    payload: error,
});

//GetAll OccupationDetails
export const getOccupationDetails = () => ({
    type: GET_OCCUPATIONDETAILS,
});
export const getOccupationDetailsSuccess = data => ({
    type: GET_OCCUPATIONDETAILS_SUCCESS,
    payload: data,
});
export const getOccupationDetailsFail = error => ({
    type: GET_OCCUPATIONDETAILS_FAIL,
    payload: error,
});

//GetAll AssetDetails
export const getAssetDetails = () => ({
    type: GET_ASSETDETAILS,
});
export const getAssetDetailsSuccess = data => ({
    type: GET_ASSETDETAILS_SUCCESS,
    payload: data,
});
export const getAssetDetailsFail = error => ({
    type: GET_ASSETDETAILS_FAIL,
    payload: error,
});

//GetAll OtherBankAccounts
export const getOtherBankAccounts = () => ({
    type: GET_OTHERBANKACCOUNTS,
});
export const getOtherBankAccountsSuccess = data => ({
    type: GET_OTHERBANKACCOUNTS_SUCCESS,
    payload: data,
});
export const getOtherBankAccountsFail = error => ({
    type: GET_OTHERBANKACCOUNTS_FAIL,
    payload: error,
});

//GetAll AccountType
export const getAccountType = () => ({
    type: GET_ACCOUNTTYPE,
});
export const getAccountTypeSuccess = data => ({
    type: GET_ACCOUNTTYPE_SUCCESS,
    payload: data,
});
export const getAccountTypeFail = error => ({
    type: GET_ACCOUNTTYPE_FAIL,
    payload: error,
});

//GetAll EntityType
export const getEntityType = () => ({
    type: GET_ENTITYTYPE,
});
export const getEntityTypeSuccess = data => ({
    type: GET_ENTITYTYPE_SUCCESS,
    payload: data,
});
export const getEntityTypeFail = error => ({
    type: GET_ENTITYTYPE_FAIL,
    payload: error,
});

//GetAll Location
export const getLocation = () => ({
    type: GET_LOCATION,
});
export const getLocationSuccess = data => ({
    type: GET_LOCATION_SUCCESS,
    payload: data,
});
export const getLocationFail = error => ({
    type: GET_LOCATION_FAIL,
    payload: error,
});

// GetByLocationId Branch
export const getBranch = data => ({
    type: GET_BRANCH,
});
export const getBranchSuccess = data => ({
    type: GET_BRANCH_SUCCESS,
    payload: data,
});
export const getBranchFail = error => ({
    type: GET_BRANCH_FAIL,
    payload: error,
});

//GetAll POI
export const getPoi = () => ({
    type: GET_POI,
});
export const getPoiSuccess = data => ({
    type: GET_POI_SUCCESS,
    payload: data,
});
export const getPoiFail = error => ({
    type: GET_POI_FAIL,
    payload: error,
});

//GetAll Reason To Become a Customer actions
export const getReasonToBecomeCustomer = () => ({
    type: GET_REASON_TO_BECOME_CUSTOMER,
});
export const getReasonToBecomeCustomerSuccess = data => ({
    type: GET_REASON_TO_BECOME_CUSTOMER_SUCCESS,
    payload: data,
});
export const getReasonToBecomeCustomerFail = error => ({
    type: GET_REASON_TO_BECOME_CUSTOMER_FAIL,
    payload: error,
});